import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6671c48a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-progress-title" }
const _hoisted_2 = { class: "upload-progress-content" }
const _hoisted_3 = { class: "upload-progress-line" }
const _hoisted_4 = { class: "upload-progress-text" }

import { t } from '@/plugins/i18n'
import { isD2C } from '@/store'
import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  failInfo: {
    type: Object,
    default: () => {
      return {}
    }
  },
  mode: {
    type: Number,
    default: 1
  }
},
  setup(__props) {

const props = __props

watch(() => props.failInfo, (newValue: any) => {

}, { deep: true, immediate: true })

return (_ctx: any,_cache: any) => {
  const _directive_drag = _resolveDirective("drag")!

  return (__props.failInfo.totalQuantity && __props.failInfo.totalQuantity > 0 && (__props.failInfo.successQuantity + __props.failInfo.failQuantity < __props.failInfo.totalQuantity) && __props.failInfo.validFlag === 1 && __props.failInfo.taskStatus === 1)
    ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([{ b2b: !_unref(isD2C)() }, 'upload-progress'])
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(__props.mode === 1 ? _unref(t)('订单创建中') : _unref(t)('商品创建中')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "upload-progress-finish",
              style: _normalizeStyle({ width: (__props.failInfo.successQuantity + __props.failInfo.failQuantity) / __props.failInfo.totalQuantity*100 + '%' })
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(__props.failInfo.successQuantity + __props.failInfo.failQuantity), 1),
            _createTextVNode("/" + _toDisplayString(__props.failInfo.totalQuantity), 1)
          ])
        ])
      ], 2)), [
        [_directive_drag]
      ])
    : _createCommentVNode("", true)
}
}

})